<div
  #mainBox
  [class.top-box]="isTopBox"
  [class.bottom-box]="isBottomBox"
  class="echoic-box pointer"
  (clickOutside)="onClickOutside()"
  [additionalElementRefs]="extraBoxes"
  (mousedown)="startLongPress()"
  (mouseup)="endLongPress($event)"
  (mouseleave)="endLongPress($event)"
  (touchstart)="startLongPress()"
  (touchend)="endLongPress($event)"
  (touchcancel)="endLongPress($event)"
>
  <div
    class="flag flex-column no-select"
    (click)="clickedBox()"
    [class.flag-all-trials]="selectedOptions.length >= requiredTrials"
  >
    {{ text }}
    <span class="sd-text">{{ target?.DiscriminativeStimulus }}</span>
    <button
      class="button-program"
      *ngIf="isBottomBox"
      [style.background-color]="getStatusColor()"
      [style.border-color]="getStatusColor()"
    >
      {{ getStatusText() }}
    </button>

    <span
      *ngIf="selectedOption"
      (click)="openExtra2($event)"
      class="badge-count"
      [style.color]="selectedOption.Color"
      [style.border-color]="selectedOption.Color"
      >{{ totalSuccess }}/{{ selectedOptions.length }}</span
    >
    <span
      *ngIf="selectedOption"
      (click)="openExtra2($event)"
      class="badge badge-left echoic-option-icon"
      [style.color]="selectedOption.Color"
      [style.border-color]="selectedOption.Color"
    >
      {{ getIcon(selectedOption) }}
    </span>

    <button class="badge-bottom-left" (click)="openDetails($event)">?</button>
    <button
      class="badge-bottom-right"
      (click)="openDetails($event)"
      title="Remaining desired Trials"
      *ngIf="remainingTrials > 0"
    >
      {{ remainingTrials }}
    </button>
  </div>
</div>
@if (detailsOpened) {
<app-target-details
  [target]="target"
  (onCloseDetails)="onCloseDetails()"
  [isPreview]="isPreview"
></app-target-details>
}
<div
  class="extra-container"
  #extraBox
  [class.hide]="!extraOpened"
  [class.big-extra-container]="isRecording || isPlayingVideo"
>
  <div class="extra-close" (click)="closeExtra()">X</div>
  <div class="extra-container-textbox">
    <div [class.hide]="justSelectedOption">
      <div
        *ngFor="let option of options"
        class="pointer data-entry-box"
        [class.data-recorded-success]="lastRecordedOptionId === option.ID"
        [class.data-buffer-active]="
          addingTargetData && cooldownOptionId === option.ID
        "
        (click)="selectOption(option)"
      >
        <div
          class="dtt-option"
          [style.background-color]="option.Color"
          [class.current]="promptSchedule && option.ID == currentPromptCodeID"
        >
          <span class="dtt-option-icon" [style.color]="option.Color">{{
            getIcon(option)
          }}</span>
          <span class="dtt-option-name">{{ option.Text }}</span>
        </div>
        <div
          class="data-entry-cooldown-bar"
          [class.data-entry-cooldown-active]="
            addingTargetData && cooldownOptionId === option.ID
          "
          aria-hidden="true"
        >
          <div class="data-entry-cooldown-bar-fill"></div>
        </div>
      </div>
    </div>
    <div [class.hide]="!justSelectedOption">
      <div [class.hide]="isRecording || isPlayingVideo">
        <div
          *ngFor="let rate of rates"
          class="pointer"
          (click)="selectRate(rate)"
        >
          <div class="dtt-option" [style.background-color]="rate.color">
            <span class="dtt-option-icon" [style.color]="rate.color">{{
              rate.icon
            }}</span>
            <span class="dtt-option-name">{{ rate.name }}</span>
          </div>
        </div>
      </div>
      <div
        class="dtt-option justify-content-center pointer"
        [class.hide]="true || isRecording"
      >
        <span
          *ngIf="!isPlayingVideo"
          class="dtt-option-icon"
          [style.color]="'#5DADE2'"
          title="Record"
          (click)="record()"
          >R</span
        >
        <span
          [class.hide]="isPlayingVideo"
          *ngIf="justSelectedOption && selectedRate?.videoBlob"
          class="dtt-option-name"
          [style.color]="'#5DADE2'"
          (click)="playVideo()"
          >See video</span
        >

        <video
          id="recordedVideo"
          width="320"
          height="240"
          controls
          class="hide"
          [src]="selectedRate?.videoUrl"
        ></video>
      </div>
      <div [class.hide]="!isRecording">
        <div
          class="dtt-option justify-content-center pointer"
          (click)="stopRecording()"
        >
          <span class="dtt-option-icon" [style.color]="'#5DADE2'" title="Stop"
            >S</span
          >
        </div>
        <video id="recordingVideo" width="320" height="240" controls></video>
      </div>
    </div>
  </div>
</div>

<div class="extra-container" #extraBox2 [class.hide]="!extra2Opened">
  <div class="extra-close" (click)="closeExtra2()">X</div>
  <div class="extra-container-textbox">
    <div *ngFor="let option of selectedOptions; let i = index">
      <span
        class="float-right extra-list-trash-icon pointer"
        (click)="deleteData(option.RecordedDate)"
        ><i class="pi pi-trash"></i
      ></span>
      {{ "@ " + option.FormattedDate }}
      <div class="dtt-option" [style.background-color]="option.Color">
        <span class="dtt-option-icon" [style.color]="option.Color">{{
          getIcon(option)
        }}</span>
        <span class="dtt-option-name">{{ option.Text }}</span>
      </div>
      <div
        class="dtt-option"
        [style.background-color]="option?.Rate?.color"
        *ngIf="option?.Rate"
      >
        <span class="dtt-option-icon" [style.color]="option?.Rate?.color">{{
          option?.Rate?.icon
        }}</span>
        <span class="dtt-option-name">{{ option?.Rate?.name }}</span>
      </div>
    </div>
  </div>
</div>
